import { ArticleFieldsFragment } from "@src/generated/graphql";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
type BlogContentProps = {
  content: ArticleFieldsFragment[];
  totalArticlesLoaded?: number;
};

const BlogContent = ({
  content,
  totalArticlesLoaded = 0,
}: BlogContentProps) => {
  const navigate = useNavigate();
  const articlePairs = content.reduce<ArticleFieldsFragment[][]>(
    (acc, article, index) => {
      if (index % 2 === 0) {
        acc.push([article]);
      } else {
        acc[acc.length - 1].push(article);
      }
      return acc;
    },
    []
  );

  return (
    <>
      {articlePairs.map((pair, pairIndex) => {
        const absoluteSectionIndex = Math.floor(
          (totalArticlesLoaded + pairIndex * 2) / 2
        );
        return (
          <div key={pairIndex} className="blog-inner-section">
            {pair.map((article, columnIndex) => {
              const baseClasses = "blog background-overlay-blog";
              const sizeClass =
                absoluteSectionIndex % 2 === 0
                  ? columnIndex % 2 === 0
                    ? "blog-big"
                    : "blog-small"
                  : columnIndex % 2 === 0
                    ? "blog-small"
                    : "blog-big";

              const isBlogType = article.articleType !== "Blog";
              const colour = article?.colour ?? "";
              return (
                <div
                  key={article.sys.id}
                  className={`${baseClasses} ${sizeClass} ${isBlogType ? "blog-type" : ""}`}
                  onClick={() => {
                    const linkUrl = article.articleLink?.linkUrl ?? "";
                    const normalizedUrl = linkUrl.startsWith("/")
                      ? linkUrl
                      : `/${linkUrl}`;
                    navigate(normalizedUrl);
                  }}
                >
                  <img
                    src={article?.thumbnailImage?.url ?? ""}
                    alt="background"
                    className="background-image"
                  />
                  <div className="blog-content">
                    {isBlogType ? (
                      <>
                        <div className="blog-logo">
                          <img
                            src={article?.mainImage?.url ?? ""}
                            alt="company logo"
                            className="company-logo"
                          />
                        </div>
                        <div className="blog-top">
                          {!isBlogType && article.eyebrowText && (
                            <p className="main-para" style={{ color: colour }}>
                              {article.eyebrowText}
                            </p>
                          )}
                          <h3 className="bold" style={{ color: colour }}>
                            {article.title}
                          </h3>
                          <p style={{ color: colour }}>
                            {article.subDescription}
                          </p>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="blog-top">
                          {article.eyebrowText && (
                            <p className="main-para" style={{ color: colour }}>
                              {article.eyebrowText}
                            </p>
                          )}
                          <h3 className="bold" style={{ color: colour }}>
                            {article.title}
                          </h3>
                          <p style={{ color: colour }}>
                            {article.subDescription}
                          </p>
                        </div>
                        <div className="blog-user">
                          <div className="blog-user-image">
                            <img
                              src={article?.author?.image?.url ?? ""}
                              alt="author"
                              className="blog-user-image"
                            />
                          </div>
                          <div className="blog-user-details">
                            <h4
                              className="font-medium"
                              style={{ color: colour }}
                            >
                              {article?.author?.name}
                            </h4>
                            <span style={{ color: colour }}>
                              {dayjs(article.publicationDate).format(
                                "MMM D, YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
};

export default BlogContent;
